import { useEffect, useState } from 'react'
import CallCenterTable from './callCenterTable';
import { TableWrapper } from '../utils/CallCenterTableWrapper';
import { ITable } from '../utils/commonInterfaces';
import helper from '../utils/helper';
import { message } from 'antd';
import { errorMessage } from '../utils/commonStringsConsts';
import tableHeaderConverter from '../utils/tableHeaderConverter';
import { useParams } from 'react-router-dom';

export default function CallCenterCutOffAndComments() {
    const { userId }: { userId: string } = useParams()
    const [lastCutOffDateTableData, setLastCutOffDateTableData] = useState<ITable>(
        { data: [], columns: [], loading: true }
    );
    const [userCommentsTableData, setUserCommentsTableData] = useState<ITable>(
        { data: [], columns: [], loading: true, total: 0, currentPage: 1, perPage: 10 }
    );

    const getUsersLastCutOffDateData = async () => {
        try {
            const res: any = await helper.getCallCenterUserLastCutOffDate(Number(userId));
            if (res?.status !== 200) {
                message.error(`${errorMessage} with last cut-off date Data`);
                return
            }
            const data = res?.data?.data
            const formattedData = data?.map((item: any) => ({
                ...item,
                Last_CutOffDate: helper.formatDate(item['Last_CutOffDate'], 'MMMM D, YYYY, hh:mm A')
            }));
            setLastCutOffDateTableData({
                data: formattedData,
                columns: data?.length > 0 ? tableHeaderConverter(data) : [],
                loading: false
            })
        } catch (error) {
            message.error(`${errorMessage} with last cut-off date Data`);
            setLastCutOffDateTableData((prev) => ({ ...prev, loading: false }));
        }
    }

    const getUserCommentsData = async (page: number, perPage: number) => {
        try {
            const res: any = await helper.getCallCenterComments(Number(userId), page, perPage);
            if (res?.status !== 200) {
                message.error(`${errorMessage} with comments data`);
                return
            }
            const data = res?.data?.data
            const formattedData = data?.map((item: any) => ({
                ...item,
                date: helper.formatDate(item['date'], 'MMMM D, YYYY, hh:mm A')
            }));
            setUserCommentsTableData((prev) => ({
                ...prev,
                data: formattedData,
                columns: data?.length > 0 ? tableHeaderConverter(data) : [],
                loading: false,
                total: res?.data?.total
            }))
        } catch (error) {
            message.error(`${errorMessage} with comments data`);
            setUserCommentsTableData((prev) => ({ ...prev, loading: false }));
        }
    }

    useEffect(() => {
        getUsersLastCutOffDateData();
        getUserCommentsData(userCommentsTableData?.currentPage as number, userCommentsTableData?.perPage as number);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTableCommentsChange = async ({ current, pageSize }: { current: number, pageSize: number }) => {
        setUserCommentsTableData((prev) => ({ ...prev, currentPage: current, perPage: pageSize, loading: true }));
        await getUserCommentsData(current, pageSize);
    }

    return (
        <>
            <div className="unPaginatedTables">
                <TableWrapper title='Last Cut-off Date:'>
                    <CallCenterTable
                        title="Users- Last Cut Off Date"
                        rows={lastCutOffDateTableData?.data}
                        columns={lastCutOffDateTableData?.columns}
                        loading={lastCutOffDateTableData?.loading}
                        pagination={false}
                        scrolling={lastCutOffDateTableData?.loading || !lastCutOffDateTableData?.data?.length ? { y: 240 } : { x: "max-content" }}
                    />
                </TableWrapper>
            </div>
            <TableWrapper title='User Comments:'>
                <CallCenterTable
                    title="Call Center: User comments"
                    rows={userCommentsTableData?.data}
                    columns={userCommentsTableData?.columns}
                    loading={userCommentsTableData?.loading}
                    pagination={{ current: userCommentsTableData?.currentPage, pageSize: userCommentsTableData?.perPage, total: userCommentsTableData?.total }}
                    handleTableChange={handleTableCommentsChange}
                    scrolling={userCommentsTableData?.data?.length ? { y: 240, x: 'max-content' } : { y: 240 }}
                />
            </TableWrapper>
        </>
    );
}
